<template>
  <v-list nav>
    <template v-for="(item, index) in items" >
      <menu-item :key="index" :item="item" v-if="!isMotor"/>
    </template>
    <v-list-item>
      <v-btn class="secondary" block @click="redirectLogout">{{ $t('logout') }}</v-btn>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  mdiTruckFastOutline,
  mdiParking,
  mdiTruckDelivery,
  mdiTruckOutline,
  mdiAccountMultiple,
  mdiCalendarRange,
  mdiAccount,
  mdiFormatListBulleted,
  mdiHandCoinOutline,
  mdiImport,
  mdiExport,
  mdiCertificate,
  mdiWarehouse,
  mdiCurrencyEur,
  mdiTruckCargoContainer,
} from '@mdi/js';

export default {
  components: {
    MenuItem: () => import(/* webpackChunkName: "menu" */ './MenuItem.vue'),
  },
  data() {
    const { VUE_APP_V2_URL: wotV2 } = process.env;

    return {
      items: [
        {
          title: this.$t('createOrder'),
          icon: mdiTruckFastOutline,
          children: null,
          to: { name: 'createLoadOrder' },
          external: false,
        },
        {
          title: this.$t('betweenDatesList'),
          icon: mdiCalendarRange,
          children: null,
          to: { name: 'listLoadOrders' },
          external: false,
        },
        {
          title: this.$t('parkList'),
          icon: mdiParking,
          children: null,
          to: { name: 'listPark' },
          external: false,
        },
        {
          title: this.$t('entriesList'),
          icon: mdiImport,
          children: null,
          to: { name: 'listParkEntries' },
          external: false,
        },
        {
          title: this.$t('exitsList'),
          icon: mdiExport,
          children: null,
          to: { name: 'listParkExits' },
          external: false,
        },
        {
          title: this.$t('clientList'),
          icon: mdiAccount,
          children: null,
          to: { name: 'listClient' },
          external: false,
        },
        {
          title: this.$t('transportersList'),
          icon: mdiTruckDelivery,
          children: null,
          to: { name: 'listTransporter' },
          external: false,
        },
        {
          title: this.$t('providerList'),
          icon: mdiTruckOutline,
          children: null,
          to: { name: 'listProvider' },
          external: false,
        },
        {
          title: this.$t('agentList'),
          icon: mdiHandCoinOutline,
          children: null,
          to: { name: 'listAgent' },
          external: false,
        },
        {
          title: this.$t('teamsList'),
          icon: mdiAccountMultiple,
          children: null,
          to: { name: 'ListTeams' },
          external: false,
        },
        {
          title: this.$t('globalList'),
          icon: mdiFormatListBulleted,
          children: null,
          to: { name: 'listGlobal' },
          external: false,
        },
        {
          title: this.$t('certifiedMaterial'),
          icon: mdiCertificate,
          children: null,
          to: { name: 'certifiedMaterial' },
          external: false,
        },
        {
          title: this.$t('createTemplate'),
          icon: mdiTruckFastOutline,
          children: null,
          to: { name: 'createDriverTemplate', query: { template: true } },
          external: false,
        },
        {
          title: this.$t('driverOrderTemplates'),
          children: null,
          icon: mdiTruckCargoContainer,
          to: `${wotV2}driver-order-templates`,
          external: true,
        },
        {
          title: this.$t('warehouse'),
          children: null,
          icon: mdiWarehouse,
          to: `${wotV2}warehouse-orders`,
          external: true,
        },
        {
          title: this.$tc('price', 2),
          icon: mdiCurrencyEur,
          children: [
            {
              title: this.$t('pricesTeam'),
              children: null,
              icon: mdiCurrencyEur,
              to: `${wotV2}prices/team`,
              external: true,
            },
            {
              title: this.$t('pricesProvider'),
              children: null,
              icon: mdiCurrencyEur,
              to: `${wotV2}prices/provider`,
              external: true,
            },
            {
              title: this.$t('pricesForwarder'),
              children: null,
              icon: mdiCurrencyEur,
              to: `${wotV2}prices/forwarder`,
              external: true,
            },
            {
              title: this.$t('pricesClient'),
              children: null,
              icon: mdiCurrencyEur,
              to: `${wotV2}prices/client`,
              external: true,
            },
            {
              title: this.$t('pricesComissionist'),
              children: null,
              icon: mdiCurrencyEur,
              to: `${wotV2}prices/comissionist`,
              external: true,
            },
            {
              title: this.$t('pricesTransporter'),
              children: null,
              icon: mdiCurrencyEur,
              to: `${wotV2}prices/transporter`,
              external: true,
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapGetters('auth', ['user', 'roles', 'isMotor']),
  },
  methods: {
    ...mapActions('auth', ['logout']),
    async redirectLogout() {
      await this.logout();

      this.$router.replace({ name: 'login' });
    },
  },
};
</script>
